/**
 *
 */

class NomiResultView {

	constructor( poolObj ) {

		this._state = StorageOperator.getStorageData('session', 'state');
		this._or34 = this._state.or34;

		//let resultData = StorageOperator.getStorageData('session', 'nb_result');
		//this._resultDataArr = resultData.array;

		this._resultDataArr = allDataObj.result;

		let pool = poolObj;
		let poolArr = pool.array;


		this._dataHangar = new DataHangar( this._resultDataArr, this._or34);
		this._contPool = new ContentsPool( this._dataHangar, poolArr);


		//   ページ間state を反映
		let userCu = this._state['userCu'+this._or34] || null;
		let userSe = this._state['userSe'+this._or34] || null;

		this._userCOp = new UserCustomOperator(this._or34, this._dataHangar.nb);
		this._userCOp.setUserCustomStateObj( userCu );
		let userCuList = this._userCOp.getUserCustomList();

		this._contPool.setUserCustomList( userCuList );
		this._contPool.setDefaultSelectState( userSe );

		this._selectTableView();

		
		//
		this._result = StorageOperator.getStorageData('session', 'resultList');

		let nowResultBooArr = this._contPool.totalDupBooArray;
		let isEquals = true;
		if(this._result) {
			let list = this._result.list;
			if(list.length===nowResultBooArr.length) {
				for(let i=0, n=list.length; i<n; i++) {
					if(list[i] !== nowResultBooArr[i]) {   isEquals = false;  break;   }
				};
			}else {
				isEquals = false;
			};
		}else {
			isEquals = false;
		};


		let resultMap = ContentsPool.resultListToResultMap( this._contPool.getSelectResultList() );
		this._tableAdd( 'resultTable', resultMap );
		//
		this._nomiPickup = new NomiPickup(resultMap, isEquals);

		// 最新の resultList を strage に
		this._setResultList( nowResultBooArr );
		//this._setResultList(resultMap);

		//
		this._addEvent();

		this._funcWindowSize();


	};



	_setResultList(booArr) {

		let arr = [];
		for(let i=0, n=booArr.length; i<n; i++) {
			if(booArr[i]) {
				arr.push(1);
			}else {
				arr.push(0);
			};
		};
		let resultListObj = {  list: arr, page: 'nomi'  };

		let boo = [true, true];
		try {
			boo = StorageOperator.setStorageData( 'session', 'resultList', resultListObj );
		}catch(exeption) {
			alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
		return boo[0];
	};





	_selectTableView() {

		let dataLast = this._resultDataArr[ this._resultDataArr.length-1 ];
		let num = dataLast.nu;
		MyUtility.setElementText( 'yosouNum', `予想回 ${Number(num)+1} 回　- ナンバーズ ${this._or34} -` );

		let key = this._userCOp.checkBoxKey;
		for(let i=0; i<key.length; i++) {
			let checkBox = this._userCOp.getCheckBox( key[i] );
			let text;
			if(key[i]==='cho') {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => array[0] === 0 ?  '無' : '有' );
			}else if( key[i]==='rea' ){
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray(), (array) => '除' );
			}else {
				text = MyUtility.arrayToString( checkBox.getTrueNumerArray() );
			}
			MyUtility.setElementText( key[i], text );
		};
		//  contPool
		MyUtility.setElementText( 'nowBox', `${this._contPool.totalDupCount} / ${this._contPool.totalDupBooArray.length}` );
		MyUtility.setElementText( 'nowStraight', `${this._contPool.totalPt} / ${this._contPool.totalDefBooArray.length}` );
		MyUtility.setElementText( 'SelectCount', this._contPool.contArray.length );

	};




	_tableAdd( tableId, resultMap ) {

		let frag = document.createDocumentFragment();
		let table = document.getElementById(tableId);
		for(let [key, val] of resultMap) {

			let ndTr = document.createElement( 'tr' );
			let ndTd = document.createElement( 'td' );
			let ndB = document.createElement( 'a' );
			ndB.className='box-text';
			let nb34 = 'nb'+key.length;

			//let href = '../numb-box/'+nb34+'/'+nb34+'-box-'+key+'.html';
			let href = '../numb-php/numb-box-data.php?box_num='+key;
			ndB.href = href;

			ndB.appendChild( document.createTextNode( key ) );
			ndTd.appendChild( ndB );

			let ndTdVal = document.createElement( 'td' );
			for(let i=0, n=val.length; i<n; i++) {
				let sp = ',  ';
				if(i===0) {   sp = '  ';   }
				ndTdVal.appendChild( document.createTextNode( sp+val[i] ) );
			};
			ndTr.appendChild( ndTd );
			ndTr.appendChild( ndTdVal );
			frag.appendChild( ndTr );

		};
		table.appendChild( frag );
	};




	_addEvent() {

		window.onscroll = function(){
			//  スクロール値取得
			let offsetY = window.pageYOffset;

			if(offsetY>550) {
				document.getElementById('skipDiv').style['display'] = 'block';
			}else {
				document.getElementById('skipDiv').style['display'] = 'none';
			};
		};
		window.addEventListener("resize", this._funcWindowSize, false);

		MyUtility.setElementEvent( 'skipTop', 'click', () => this._skipeTop(), false );
		MyUtility.setElementEvent( 'skipBottom', 'click', () => this._skipeBottom(), false );
	};



	//  DOM 操作

	_funcWindowSize() {

		var width = window.innerWidth;

		if(width > 1200) {
			document.getElementById("skipDiv").style.right = (width-1100)/2-60+'px';
		}else if(width>500){
			document.getElementById("skipDiv").style.right = "20px";
		}else {
			document.getElementById("skipDiv").style.right = "10px";
			document.getElementById("skipDiv").style.bottom = "8px";
		};
	};


	_skipeTop() {

		const offsetY = window.pageYOffset;

		const range = offsetY > 2000 ? offsetY/20 :  100;

		let timer = window.setInterval( () => this._windowScroll( timer, true, range, 0), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		let timer2 = window.setTimeout( () => window.clearInterval( timer ), 500);

	};
	_skipeBottom() {

		const offsetY = window.pageYOffset;
		const windowH = window.innerHeight;

		const footerTop = offsetY+document.getElementById('footerTop').getBoundingClientRect().top;

		const range = footerTop-offsetY > 2000 ? (footerTop-offsetY)/20 : 100;

		let timer = window.setInterval( () => this._windowScroll( timer, false, range, footerTop-windowH ), 12 );

		//  _windowScroll メソッド内での clearInterval()が、働かなかった場合の保険
		let timer2 = window.setTimeout( () => window.clearInterval( timer ), 500);

	};


	_windowScroll( timer, isUpDown, range, end) {

		let offsetY = window.pageYOffset;

		if(isUpDown) {
			if(end>=offsetY) {
				window.clearInterval( timer );
			}else {
				offsetY = offsetY-range < end ? end : offsetY-range;
				window.scroll(0, offsetY);
			};
		}else {
			if(end-20<=offsetY) {
				window.clearInterval( timer );
			}else {
				offsetY = offsetY+range > end ? end : offsetY+range;
				window.scroll(0, offsetY);
			};
		};
	};



};  //classEnd



